import type { AuditTriage } from "../../../shared/aeoAuditTriage";

const fixCopy: Record<string, string> = {
  "核對此頁是否要出現在搜尋結果；需要時移除noindex":
    "本頁設為不顯示在搜尋結果；若要開放搜尋，請移除禁止收錄設定（noindex）",
  "保留現有內容，補充本頁規格、用途或直接回答":
    "保留原文，補充本頁商品的規格、用途，或直接回答頁面主題的問題",
  補上實際撰寫或維護單位與可驗證來源:
    "文章未標示作者或維護單位，請在開頭或文末補上名稱，並為引用資料附上來源連結",
  補上實際規格與價格區間及差異依據:
    "本頁未找到價格資訊，請補上各規格售價或價格區間，並說明價差",
  "檢查此頁是否直接回答上述需求，保留正文並補上缺少的選購比較與商品連結":
    "檢查讀者能否從本頁比較商品規格、用途與價格，並找到商品連結；缺少的資訊再補上",
  "保留商品說明，補齊選購所需的規格、用途、價格差異與來源依據":
    "檢查各規格是否寫清楚用途、售價與差異，缺項再補齊；涉及檢驗或來源的說明，附上可核對的資料",
  "核對已被引用的答案與規格仍正確，補上可驗證來源":
    "核對被引用的答案與商品規格，若有過時資訊就更新，並補上來源連結",
};

export function auditActionItems(triage: AuditTriage): string[] {
  let lifecycleAction: string | undefined;
  switch (triage.lifecycle) {
    case "活動日期待確認":
      lifecycleAction =
        "先確認活動是否仍有效；仍有效就補上完整起訖日期，已結束就標明結束並連到現行活動";
      break;
    case "歷史活動轉回首頁":
      lifecycleAction =
        "舊活動網址已轉到首頁，請把站內仍指向此網址的活動連結改為現行活動或相關商品分類";
      break;
    case "歷史活動已撤下":
      lifecycleAction =
        "舊活動頁已無法開啟，請更新站內活動連結與網站地圖，改連到可用的活動或商品頁";
      break;
    case "過期活動":
      lifecycleAction = `活動已${triage.endDate ? `於 ${triage.endDate} ` : ""}結束，請在原頁標示已結束，並附上現行活動或相關商品連結`;
      break;
    case "現行活動":
      lifecycleAction =
        "核對活動優惠、適用商品與期限是否正確，缺少的資訊再補齊";
      break;
    case "未開始活動":
      lifecycleAction = "確認活動開始日期、優惠與適用商品，補齊缺少的活動說明";
      break;
    case "活動已轉址":
    case "已轉址":
      lifecycleAction =
        "此網址已轉到其他頁，請確認新頁是否正確，並更新站內仍指向舊網址的連結";
      break;
    case "檢查失敗":
      lifecycleAction = "本次未能完成檢查，請先確認網址可正常開啟，再重新檢查";
      break;
  }
  const items = triage.fixes.map(fix => {
    const mismatch =
      /^核對「(.+)」是否由此頁承接，補足對應內容或連向正確品類$/.exec(fix);
    if (mismatch)
      return `針對「${mismatch[1]}」檢查本頁商品是否對應，缺少的規格與價格說明再補上；相關商品在其他分類時，加上該分類連結`;
    if (fix === "補齊與本頁商品或問題一致的標題及H1") {
      if (triage.reasons.includes("缺少H1"))
        return "頁面缺少主標題，請補上與本頁商品或主題一致的主標題";
      if (triage.reasons.includes("缺少title"))
        return "頁面缺少網頁標題，請補上與本頁商品或主題一致的網頁標題";
      return "檢查網頁標題與頁面主標題是否完整、符合本頁主題，缺項再補上";
    }
    return fixCopy[fix] || fix;
  });
  if (lifecycleAction) items.unshift(lifecycleAction);
  return items.length ? items : ["目前沒有列出待修改項目，先維持現有內容"];
}
